import React from "react";

import { DealContentPicker } from "components/Prompts/Deal-content-picker";
import { IAiFile, IFile, IFileUploadType } from "store/types";

export interface FilesPickerModalProps {
  currentFiles: IAiFile[];
  filesPickerModalOpen: boolean;
  onClose: () => void;
  mode?: FilesPickerMode;
  filesPickerSubmit: (data: {
    filesIds?: number[];
    attachments: File[];
    files?: IFile[];
    dealId?: number | null;
  }) => Promise<void>;
  title: string;
  workspaceTitle: string;
  singleFileSelection?: boolean;
  dealId: number | null;
  getFilesOutsideDeal?: boolean;
  fileUploadType?: IFileUploadType[];
  attachedFiles?: File[];
  selectWithoutFiles?: boolean;
  acceptedFilesExtensions?: string[];
  onSelectFileForMe?: () => void;
  isFileForMeSelected?: boolean;
}

export enum FilesPickerMode {
  Document = "document"
}

export const FilesPickerModal: React.FC<FilesPickerModalProps> = ({
  currentFiles,
  filesPickerModalOpen,
  onClose,
  filesPickerSubmit,
  title,
  singleFileSelection = false,
  dealId,
  getFilesOutsideDeal = false,
  fileUploadType,
  attachedFiles,
  selectWithoutFiles = false,
  acceptedFilesExtensions,
  onSelectFileForMe,
  isFileForMeSelected
}) => {
  return (
    <DealContentPicker
      mode="file"
      open={filesPickerModalOpen}
      title={title}
      currentFiles={currentFiles}
      onClose={onClose}
      onSubmit={filesPickerSubmit}
      singleFileSelection={singleFileSelection}
      dealId={dealId}
      getFilesOutsideDeal={getFilesOutsideDeal}
      fileUploadType={fileUploadType}
      attachedFiles={attachedFiles}
      selectWithoutFiles={selectWithoutFiles}
      acceptedFilesExtensions={acceptedFilesExtensions}
      onSelectFileForMe={onSelectFileForMe}
      isFileForMeSelected={isFileForMeSelected}
    />
  );
};
